const COLOR = {
  // Primary Colours
  PRIMARY_PINK: '#FF495B',
  PRIMARY_BLUE: '#3637DF',
  PRIMARY_DARKBLUE_HOVER: '#3637dfe6',
  PRIMARY_DARK_GREY: '#333',
  PRIMARY_LIGHT_GREY: '#C2BBD7',
  PRIMARY_WHITE: '#fff',
  PRIMARY_BLACK: '#333',

  SECONDARY_BLUE: '#3898EB',
  SECONDARY_GREY: '#33333380',

  // // Neutral Colours
  // NEUTRAL_GREY_1: '#373F41',
  NEUTRAL_GREY_2: '#E2E5E6',
  // NEUTRAL_GREY_3_HOVER: '#909090',
  // NEUTRAL_GREY_3: '#F4F5F4',
  // NEUTRAL_GREY_4: '#767676',
  // NEUTRAL_GREY_5: '#323232',
  // NEUTRAL_GREY_6: '#F4F4F4',

  // Support Colours
  SUPPORT_VALID: '#00A03C',
  SUPPORT_INVALID: '#EC0000',
  SUPPORT_FOCUS: '#FEC813'
}

export default COLOR
